import { Component } from 'react'

export default class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
        <div className="text-center flex flex-col items-center gap-4">
          <p className="text-8xl font-black text-accent">500</p>
          <h1 className="text-2xl font-bold text-fg">Ошибка сервера</h1>
          <p className="text-sm max-w-xs text-muted">
            Что-то пошло не так. Попробуйте обновить страницу или вернитесь на главную
          </p>
          <div className="flex gap-3 mt-2">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-xl font-bold text-sm transition-all hover:opacity-90 bg-accent text-on-accent"
            >
              Обновить страницу
            </button>
            <a
              href="/"
              className="px-6 py-3 rounded-xl font-bold text-sm border border-line text-fg transition-all hover:border-accent"
            >
              На главную
            </a>
          </div>
        </div>
      </div>
    )
  }
}
